import {
    SET_CURRENT_PAGE
} from '../actions/taboolaActions';

const initialState = {
    currentPage: undefined
};

export function taboola(state = initialState, action)
{
    switch (action.type)
    {
        case SET_CURRENT_PAGE:
        {
            return {
                ...state,
                currentPage: action.payload
            }   
        }
    }

    return state;
}
